import { applyMiddleware, combineReducers, createStore } from 'redux';
import {
	borrowerCollectionReducer,
	investorCollectionReducer,
	systemSettingsDataReducer,
} from './reducers';
import { thunk } from 'redux-thunk';

// add functions inside the combineReducers
const rootReducer = combineReducers({
	investorCollectionReducer,
	borrowerCollectionReducer,
	systemSettingsDataReducer
});

export const Store = createStore(rootReducer, applyMiddleware(thunk));
